<template lang="pug">
  .profile-select-list
    fieldset
      .row.profile-wrap(v-for="profile in profiles" :key="profile.paymentProfileId")
        .choice.xs-12
          MrRadio(v-model="selectedProfileId" :value="profile.paymentProfileId" name="profile")
            PaymentProfile(:profile="profile")

</template>

<script>
  import { mapState } from "vuex";
  import MrRadio from "../mrRadio";
  import PaymentProfile from "./PaymentProfile";

  export default {
    name: "PaymentProfileList",
    components: {
      PaymentProfile,
      MrRadio
    },

    computed: {
      ...mapState('payments', [
        'profiles'
      ]),

      selectedProfileId: {
        get() {
          return this.$store.state.payments.selectedProfileId;
        },

        set(val) {
          this.$store.commit('payments/setSelectedProfileId', val);
        }
      }
    },

  }
</script>

<style scoped lang="stylus">
  .profile-wrap
    padding-bottom 1.5em

  .profile
    display inline-block
    padding-left 0.5em
    vertical-align top

</style>